import * as React from 'react';

type Props = {
    checked: boolean,
    name: string,
    label: string,
    value: string,
    id?: string,
    onChange: (evt: React.SyntheticEvent<HTMLInputElement>) => void
    fontFamily?: string
}

const grpStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row', // fixed your typo from 'flexDirextion' too
    alignItems: 'center',
    color: 'inherit'
}

const baseLblStyle: React.CSSProperties = {
    fontWeight: 100,
    textTransform: 'uppercase',
    fontFamily: 'Reitam',
    color: 'rgba(66, 66, 66, 0.8)',
    marginRight: '15px'
}

const inputStyle: React.CSSProperties = {
    margin: '0 3px 0 0',
    width: '25px',
    height: '25px'
}

export class Checkbox extends React.Component<Props, any> {

    constructor(props: Props) {
        super(props);
        this.state = { 
            checked: props.checked || false 
        };
    }

    getLabelStyle = (): React.CSSProperties => {
        return {
            ...baseLblStyle,
            fontFamily: this.props.fontFamily || baseLblStyle.fontFamily
        };
    }

    handleClick = (e: any) => {
        this.setState({ checked: e.target.checked })
    }

    render() {
        return (
            <div style={grpStyle}>
                <div style={this.getLabelStyle()} className="chkBoxLabel">{this.props.label}</div>
                <input
                    style={inputStyle}
                    onClick={this.handleClick}
                    type="checkbox"
                    name={this.props.name}
                    checked={this.state.checked}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    id={this.props.id}
                />
            </div>
        )
    }
}
